import { PureComponent } from "react";

import {
    AccountingConnectionStatus,
    AccountingConnectionStatusText,
} from "commonComponents/financial/Common/Accounting.types";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

type CellType = AccountingConnectionStatus | undefined;

class AccountingConnectionStatusCell extends PureComponent<IGridCellRenderProps<CellType>> {
    render() {
        if (
            this.props.cellValue === AccountingConnectionStatus.Connected ||
            this.props.cellValue === AccountingConnectionStatus.PendingSync
        ) {
            const statusType =
                this.props.cellValue === AccountingConnectionStatus.Connected
                    ? "success"
                    : "pending";
            return (
                <StatusTagDisplay
                    statusType={statusType}
                    statusText={AccountingConnectionStatusText.get(this.props.cellValue)}
                />
            );
        }
        return null;
    }
}

export const columnAccountingConnectionStatus: IClientGridColumn<CellType> = {
    columnType: GridColumnType.accountingConnectionStatus,
    Cell: AccountingConnectionStatusCell,
};
